import type { ILiteTradeAccetClass } from "../../../modules/LiteTrade/types/liteTradeReducer.t";
import { COLLECTION_ASSETS_ATTRIBUTES, COLLECTION_KEYS } from "./mobileMarketConstants";
import { Many } from "lodash"

interface IGetMobileMarketOrderParamsByCollectionKeyReturn {
    directions: Many<boolean | "asc" | "desc">
    fields: Many<string>
}

export const getMobileMarketOrderParamsByCollectionKey = (collectionKey: string): IGetMobileMarketOrderParamsByCollectionKeyReturn => {
    switch (collectionKey) {
        case COLLECTION_KEYS.LAST_VIEWED:
            return {
                fields: ['updatedAt'],
                directions: ['desc'],
            }
        default:
            return {
                fields: ['inactive', 'emptyPosition', 'position', 'lowerDescription'],
                directions: ['asc', 'asc', 'asc', 'asc']
            }
    }
}

export const filterMobileMarketAssetsByAttribute = (item: { assetClass: ILiteTradeAccetClass }, attribute: string, value: string) => {
    switch (attribute) {
        case COLLECTION_ASSETS_ATTRIBUTES.ASSET_CLASS:
            return item.assetClass === value
        default:
            return true;
    }
};
